import { FC, useEffect, useState } from 'react';
import { Table, TableColumnsType } from 'antd';
import { ITutorClass } from '../../models/tutor/tutorClass.model';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import TargetStudentModal from './modals/TargetStudentModal';

interface IProps {
  data: ITutorClass[];
  date: string;
}

const ClassTable: FC<IProps> = ({
  data,
  date,
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  const [sortedData, setSortedData] = useState<ITutorClass[]>();
  const [targetStudentVisible, setTargetStudentVisible] = useState<boolean>(false);
  const [record, setRecord] = useState<ITutorClass>();

  useEffect(() => {
    if (data) {
      setSortedData(_.sortBy(data, 'srtTime'));
    }
  }, [data]);

  const column: TableColumnsType<ITutorClass> = [
    {
      title: t('common.menu.class'),
      dataIndex: 'className',
      align: 'center',
      render: (value, record) => (
        <a
          onClick={() => {
            history.push(`/class?classCode=${record.classCode}&timetableCode=${record.timetableCode}&date=${date}`);
          }}
        >
          <u>{value}</u>
        </a>
      )
    },
    {
      title: t('common.column.time'),
      dataIndex: 'srtTime',
      align: 'center',
    },
    {
      title: t('common.column.classroom'),
      dataIndex: 'classRoomName',
      align: 'center',
    },
    {
      title: t('common.column.num'),
      dataIndex: 'studentTotal',
      align: 'center',
    },
    {
      title: t('class.tutor.column1'),
      dataIndex: 'applyRate',
      align: 'center',
      render: value => typeof value === 'number' ? `${value}%` : '-',
    },
    {
      title: t('class.tutor.column2'),
      dataIndex: 'avgScore',
      align: 'center',
      render: value => typeof value === 'number' ? `${value}%` : '-',
    },
    {
      title: t('class.tutor.column3'),
      dataIndex: 'managementTargetCount',
      align: 'center',
      render: (value, record) => (
        <a
          onClick={() => {
            setRecord(record);
            setTargetStudentVisible(true);
          }}
        >
          <u>{value}</u>
        </a>
      )
    },
  ];

  return (
    <>
      <div className="comm-bx__between">
        <div className="comm-sch_result"><b>Today Classes</b></div>
      </div>
      <div className='comm-table__area table-wrap'>
        <Table
          columns={column}
          dataSource={sortedData}
          pagination={{
            pageSize: 9999999,
          }}
        />
      </div>

      {targetStudentVisible &&
        <TargetStudentModal
          visible={targetStudentVisible}
          setVisible={setTargetStudentVisible}
          record={record}
          date={date}
        />
      }
    </>
  );
};

export default ClassTable;
